export const enum RewindDirection {
  Backward,
  Forward,
}
